import * as React from "react";
import { Link,withRouter } from "react-router-dom";
// import Logo from './../../assets/images/logo.png';
import $ from "jquery";
import Countdown from "react-countdown";
import { FaClinicMedical, FaHandHoldingMedical } from "react-icons/fa";
import {
  getCookie,
  getStorage,
  getUserDetail,
  setCookie,
  setStorage,
} from "../../utils";
import CONSTANT from "./../../constant";

import { restartLoggedInUserSession } from "../../actions/AuthAction";
import "./../../assets/css/sidebar.css";
import constant from "./../../constant";

export class SessionTimer extends React.PureComponent<any, any> {
  private timerInterval: NodeJS.Timeout | null = null;

  constructor(props: any) {
    super(props);

    const ud = getUserDetail();
    const issuedAt = ud?.issuedAt ?? Date.now();
    const delayMs = 8 * 60 * 60 * 1000; // 8 hours in milliseconds
    // const delayMs = 1 * 60 * 1000; // for testing

    this.state = {
      value: issuedAt + delayMs,
      ud,
      hasAlertShown: false, // track if alert has been shown
    };
  }

  componentDidMount() {
    // Set up an interval to check the remaining time
    this.timerInterval = setInterval(this.checkRemainingTime, 1000);
  }

  componentWillUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  checkRemainingTime = () => {
    const { value, hasAlertShown } = this.state;
    const now = Date.now();
    const remainingTime = value - now;
    const tenMinutes = 10 * 60 * 1000;

    if (remainingTime <= tenMinutes && !hasAlertShown) {
      // Show alert when less than 10 minutes remain and alert hasn't been shown yet
      alert("Your session will expire in 10 minutes. Please save your work.");
      this.setState({ hasAlertShown: true });

      // Optionally restart the session automatically
      // this.restartSession();
    }
  };

  shouldComponentUpdate(nextProps: any, nextState: any) {
    return false;
  }

  restartSession() {
    let ud = getUserDetail();

    if (ud) {
      restartLoggedInUserSession(ud.code)
        .then((response: any) => {
          if (response.status == constant.static.apiStatus.success) {
            this.setState(
              {
                ...this.state,
                value: Date.now() + 8 * 60 * 60 * 1000, // reset to 8 hours
                hasAlertShown: false, // reset alert flag
              },
              () => {
                setCookie(CONSTANT.cookie.token, response.result.token);
                setCookie(
                  CONSTANT.cookie.userDetail,
                  response.result.userDetail
                );
              }
            );
          }
        })
        .catch((err: any) => {
          alert(err);
        });
    }
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div
            className={
              this.state.b_list !== undefined && this.state.b_list.length !== 0
                ? "col-2 : bg-white"
                : "col-2"
            }
          >
            <Countdown
              date={this.state.value}
              renderer={({ hours, minutes, seconds, completed }) => {
                if (completed) {
                  return <span>Session expired</span>;
                } else {
                  return (
                    <div className="d-flex font-bold justify-content-between align-items-center p-2">
                      <h4 className="d-flex text-nowrap timerarea">
                        {hours.toString().padStart(2, "0")}:
                        {minutes.toString().padStart(2, "0")}:
                        {seconds.toString().padStart(2, "0")}
                      </h4>
                    </div>
                  );
                }
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

class Header extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      userDetail: getCookie(CONSTANT.cookie.userDetail),
      finance: getCookie(CONSTANT.cookie.finance),
      ud: 1860,
      isExpanded: true,
      openSubmenus: "",
    };
  }

  toggleMenu = () => {
    this.setState({ isExpanded: !this.state.isExpanded, openSubmenus: "" });
  };

  toogleopenSubmenus = (value: string) => {
    this.setState((prevState: any) => ({
      openSubmenus: prevState.openSubmenus === value ? "" : value,
    }));
  };

  componentDidMount() {
    const body = document.body,
      html = document.documentElement;
    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    $(".left-menu").height("auto");

    // Check initial route
    this.checkAndCloseSidebar();
  }

  componentDidUpdate(prevProps: any) {
    // Check if the route has changed
    if (this.props.location?.pathname !== prevProps.location?.pathname) {
      this.checkAndCloseSidebar();
    }
  }

  // ✅ UPDATED: Only match /file/:code where code is a NUMBER
  checkAndCloseSidebar = () => {
    const currentPath = this.props.location?.pathname || window.location.pathname;
    // This pattern matches /file/ followed by one or more digits only
    const fileRoutePattern = /^\/file\/\d+$/;
    
    if (fileRoutePattern.test(currentPath)) {
      this.setState({ isExpanded: false, openSubmenus: "" });
    }
  };

  render() {
    const ud = getCookie(CONSTANT.cookie.userDetail);
    const permissions = getStorage(CONSTANT.cookie.permissions);
    const { userDetail } = this.state;
    const { isExpanded } = this.state;

    return (
      <div className="h-screen left-menu">
        <div
          className={`stickyaside transition-all duration-500 ease-in-out ${
            isExpanded ? "w-64" : "w-15"
          } flex flex-col shadow-xl`}
        >
          {/* Header */}
          <div className="p-2 flex items-center justify-between">
            {isExpanded && (
              <h2 className="text-xl font-bold whitespace-nowrap text-white pl-4">
                File Menu
              </h2>
            )}
            <button
              onClick={this.toggleMenu}
              className={`p-2 rounded-lg hover:bg-blue-900 transition-colors ${
                isExpanded ? "mx-right" : "mx-auto"
              } text-white`}
            >
              {isExpanded ? (
                <i className="fa fa-times text-xl"></i>
              ) : (
                <i className="fa fa-bars text-xl"></i>
              )}
            </button>
          </div>
          <div className="navbar navbar-expand-lg p-0">
            <div className="w-100">
              {/* <div className="logo">
                 <Link
                  to={
                    ud.designationCode === 370
                      ? CONSTANT.component.dakManagementCreate.url
                      : CONSTANT.component.userFileList.url
                  }
                >
                  <img src={logo} alt="logo" />
                </Link>
              </div> */}
              <ul>
                <li>
                  <Link to={CONSTANT.component.userFileList.url}>
                    <i className="fa fa-file-text-o"></i>
                    {isExpanded && "DashBoard"}
                  </Link>
                </li>
              </ul>

              {ud.designationCode === 370 ? (
                <ul>
                  <li>
                    <Link to={CONSTANT.component.dakManagementCreate.url}>
                      <i className="fa fa-file-archive-o" />
                      {isExpanded && "DAK Management"}
                    </Link>
                  </li>
                </ul>
              ) : (
                <ul>
                  {permissions?.indexOf(
                    CONSTANT.static.permissions.hodFileReport
                  ) > -1 && (
                    <>
                      <li>
                        <Link to={CONSTANT.component.userFileReport.url}>
                          <i className="fa fa-bar-chart" />
                          {isExpanded && "HOD Report"}
                        </Link>
                      </li>
                      {/* <li>
                        <Link to={CONSTANT.component.pendingHodFiles.url}>
                          <i className="fa fa-bar-chart" />
                          {isExpanded && "Pending For Approval"}
                        </Link>
                      </li> */}
                    </>
                  )}
                  {
                    <React.Fragment>
                      <li className="text-white">
                        <button
                          className="flex justify-content-between w-100"
                          onClick={() => {
                            if (isExpanded) {
                              this.toogleopenSubmenus("E-Filing");
                            }
                          }}
                        >
                          <i className="fa fa-file-text-o text-white" />
                          {isExpanded && "E-Filing"}

                          {/* Only show chevron icons when menu is expanded */}
                          {isExpanded &&
                            (this.state.openSubmenus == "E-Filing" ? (
                              <i className="fa fa-chevron-down transition-transform duration-300 ml-1 text-white ml-auto"></i>
                            ) : (
                              <i className="fa fa-chevron-right transition-transform duration-300 ml-1 text-white ml-auto"></i>
                            ))}
                        </button>
                        <div
                          className={`overflow-hidden transition-all duration-500 ease-in-out ${
                            this.state.openSubmenus == "E-Filing"
                              ? "max-h-96 opacity-100"
                              : "max-h-0 opacity-0"
                          }`}
                        >
                          <ul
                            className="mt-2 space-y-1 border-l-2 border-blue-500 pt-1"
                            key={this.state.openSubmenus}
                          >
                            {/* <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                to={constant.component.DraftList.url}
                                className="flex items-center transition-all duration-200 group"
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  Draft
                                </span>
                              </Link>
                            </li> */}
                            {/* <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                className="flex items-center transition-all duration-200 group"
                                to={constant.component.userAddFile.url}
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  Create
                                </span>
                              </Link>
                            </li> */}
                            {/* <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                className="flex items-center transition-all duration-200 group"
                                to={constant.component.DraftList.url}
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  Submitted for Approval
                                </span>
                              </Link>
                            </li> */}
                            <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                className="flex items-center transition-all duration-200 group"
                                to={constant.component.myFiles.url}
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  My Files
                                </span>
                              </Link>
                            </li>
                            <li className="px-2 py-1 border-0">
                              <Link
                                to={constant.component.inbox.url}
                                className="flex items-center transition-all duration-200 group"
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  Inbox
                                </span>
                              </Link>
                            </li>
                            <li className="px-2 py-1 border-0">
                              <Link
                                to={constant.component.outbox.url}
                                className="flex items-center transition-all duration-200 group"
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  Outbox
                                </span>
                              </Link>
                            </li>
                            { ud?.isHOD && (
                              <li className="px-2 py-1 border-0 bg-none">
                                <Link
                                  className="flex items-center transition-all duration-200 group"
                                  to={CONSTANT.component.pendingHodFiles.url}
                                >
                                  <i className={``} />
                                  {isExpanded && "Pending Approval"}
                                </Link>
                              </li>
                            )}
                          </ul>
                        </div>
                      </li>

                      {/* <li className="text-white">
                        <button
                          className="flex justify-content-between w-100"
                          onClick={() => {
                            if (isExpanded) {
                              this.toogleopenSubmenus("APAR");
                            }
                          }}
                        >
                          <i className="fa fa-file-text-o text-white" />
                          {isExpanded && "APAR"}

                          {isExpanded &&
                            (this.state.openSubmenus == "APAR" ? (
                              <i className="fa fa-chevron-down transition-transform duration-300 ml-1 text-white ml-auto"></i>
                            ) : (
                              <i className="fa fa-chevron-right transition-transform duration-300 ml-1 text-white ml-auto"></i>
                            ))}
                        </button>
                        <div
                          className={`overflow-hidden transition-all duration-500 ease-in-out ${
                            this.state.openSubmenus == "APAR"
                              ? "max-h-96 opacity-100"
                              : "max-h-0 opacity-0"
                          }`}
                        >
                          <ul
                            className="mt-2 space-y-1 border-l-2 border-blue-500 pt-1"
                            key={this.state.openSubmenus}
                          >
                            {permissions?.indexOf(
                              CONSTANT.static.permissions.aparHRAccess
                            ) > -1 && (
                              <>
                                <li className="px-2 py-1 border-0 bg-none">
                                  <Link
                                    className="flex items-center transition-all duration-200 group"
                                    to={constant.component.manageEmployee.url}
                                  >
                                    <i className={``} />
                                    <span className="font-normal whitespace-nowrap">
                                      Manage Employee
                                    </span>
                                  </Link>
                                </li>
                                <li className="px-2 py-1 border-0 bg-none">
                                  <Link
                                    className="flex items-center transition-all duration-200 group"
                                    to={constant.component.startAppraisalCycle.url}
                                  >
                                    <i className={``} />
                                    <span className="font-normal whitespace-nowrap">
                                      Start Appraisal Cycle
                                    </span>
                                  </Link>
                                </li>
                              </>
                            )}
                            <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                className="flex items-center transition-all duration-200 group"
                                to={constant.component.viewReports.url}
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  View Reports
                                </span>
                              </Link>
                            </li>
                            {permissions?.indexOf(
                              CONSTANT.static.permissions.aparHRAccess
                            ) > -1 && (
                              <li className="px-2 py-1 border-0 bg-none">
                                <Link
                                  className="flex items-center transition-all duration-200 group"
                                  to={constant.component.selfAppraisal.url}
                                >
                                  <i className={``} />
                                  <span className="font-normal whitespace-nowrap">
                                    Self Appraisal
                                  </span>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </div>
                      </li> */}

                      {/*
                          permissions.indexOf(
                            CONSTANT.static.permissions.circularModule
                          ) > -1   || userDetail.isHOD ?   <li>
                          <Link to={CONSTANT.component.circularList.url}>
                          <i className="fa fa-circle-o-notch" aria-hidden="true"></i>
                            Circular 
                          </Link>
                        </li> :""
                          */}

                      <li>
                        <Link to={CONSTANT.component.circularList.url}>
                          <i
                            className="fa fa-circle-o-notch"
                            aria-hidden="true"
                          ></i>
                          {isExpanded && "Circular"}
                        </Link>
                      </li>

                      {permissions?.indexOf(
                        CONSTANT.static.permissions.deleteFileAccess
                      ) > -1 && (
                        <li>
                          <Link to={CONSTANT.component.dltFIles.url}>
                            <i className="fa fa-trash" aria-hidden="true"></i>
                            {isExpanded && "Delete Files"}
                          </Link>
                        </li>
                      )}

                      <li>
                        <Link to={CONSTANT.component.userParkedFileList.url}>
                          <i className="fa fa-file-archive-o" />
                          {isExpanded && "Parked Files"}
                        </Link>
                      </li>

                      {/* <li>
                        <Link to={CONSTANT.component.userParkedFileList.url}>
                        <i className="fa fa-thumb-tack" aria-hidden="true"></i>
                          Parked File  
                        </Link>
                      </li> */}

                      <li>
                        <Link to={CONSTANT.component.approvedFileReport.url}>
                          <i className="fa fa fa-check-circle" />
                          {isExpanded && "Approved Files"}
                        </Link>
                      </li>

                      {permissions?.indexOf(
                        CONSTANT.static.permissions.dakAccess
                      ) > -1 && (
                        <li>
                          <Link to={CONSTANT.component.dakManagementCreate.url}>
                            <i className="fa fa-file" />
                            {isExpanded && "DAK Management"}
                          </Link>
                        </li>
                      )}
                    </React.Fragment>
                  }

                  {permissions?.indexOf(
                    CONSTANT.static.permissions.kmMenuAccess
                  ) > -1 && (
                    <li>
                      <Link
                        to={CONSTANT.component.knowledgeManagementSystem.url}
                      >
                        <i className="fa fa-arrow-down" aria-hidden="true" />
                        {isExpanded && "Knowledge Management"}
                      </Link>
                    </li>
                  )}

                  {
                    <li>
                      <Link to={CONSTANT.component.userETourList.url}>
                        <i className="fa fa-plane" />
                        {isExpanded && "E-Tour"}
                      </Link>
                    </li>
                  }

                  {
                    <li>
                      <Link to={CONSTANT.component.listMedicalClaim.url}>
                        <i className="fa fa-heartbeat" />
                        {isExpanded && "Medical Claim"}
                      </Link>
                    </li>
                  }

                   {
                    <li>
                      <Link to={CONSTANT.component.EmpPropertyReturn.url}>
                        <i className="fa fa-file"/>
                        {isExpanded && "Property Return"}
                      </Link>
                    </li>
                  }

                  {
                    <li>
                      <a href="https://apar.epieoffice.in/" target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-star"/>
                        {isExpanded && "APAR SPARROW"}
                      </a>
                    </li>
                  }

                  {Array.isArray(
                    getStorage(CONSTANT.cookie.hrDealingOfficerList)
                  ) &&
                  getStorage(CONSTANT.cookie.hrDealingOfficerList).length > 0 &&
                  this.state.userDetail.code ===
                    getStorage(CONSTANT.cookie.hrDealingOfficerList)[0].code ? (
                    <li>
                      <Link to={CONSTANT.component.medicalDesk.url}>
                        <i className="" style={{ float: "left" }}>
                          <FaHandHoldingMedical />
                        </i>
                        {isExpanded && "Medical Desk"}
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}

                  {this.state.userDetail.code ==
                    getStorage(CONSTANT.cookie.hrexecutive)[0].code ||
                  getStorage(CONSTANT.cookie.finance).some(
                    (ele: any) => ele.code == this.state.userDetail.code
                  ) ? (
                    <li>
                      <Link to={CONSTANT.component.medicalDesk.url}>
                        <i className="" style={{ float: "left" }}>
                          <FaClinicMedical />{" "}
                        </i>
                        {isExpanded && "Medical Desk Admin"}
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}

                  {permissions?.indexOf(
                    CONSTANT.static.permissions.probationCompletionConfirmation
                  ) > -1 && (
                    <li>
                      <Link
                        to={
                          CONSTANT.component.probationCompletionConfirmation.url
                        }
                      >
                        <i className="fa fa-address-card" />
                        {isExpanded && "Probation Completion Confirmation"}
                      </Link>
                    </li>
                  )}

                  {permissions?.indexOf(
                    CONSTANT.static.permissions.probationCompletionInitiation
                  ) > -1 && (
                    <li>
                      <Link
                        to={
                          CONSTANT.component.probationCompletionInitiation.url
                        }
                      >
                        <i className="fa fa-address-card" />
                        {isExpanded && "Probation Completion Initiation"}
                      </Link>
                    </li>
                  )}
                </ul>
              )}

              <ul>
                {permissions?.indexOf(
                  CONSTANT.static.permissions.userAdminAccess
                ) > -1 && (
                  <li>
                    <Link to={CONSTANT.component.adminDashboard.url}>
                      <i className="fa fa-cog" />
                      {isExpanded && "Admin section"}
                    </Link>
                  </li>
                )}
                {/* <li>
                  <Link to={CONSTANT.component.userProfile.url}>
                    <i className="fa fa-user-circle" /> {ud.name}
                  </Link>
                </li>
                <li>
                  <Link to={CONSTANT.component.userChangePassword.url}>
                    <i className="fa fa-key" />
                    Change Password
                  </Link>
                </li>
                <li>
                  <Link to={CONSTANT.component.logout.url}>
                    <i className="fa fa-sign-out" />
                    Log out
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Header);